import { render, staticRenderFns } from "./home-type3.vue?vue&type=template&id=0fc1bdf6&scoped=true"
import script from "./home-type3.vue?vue&type=script&lang=js"
export * from "./home-type3.vue?vue&type=script&lang=js"
import style0 from "./home-type3.vue?vue&type=style&index=0&id=0fc1bdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1bdf6",
  null
  
)

export default component.exports